var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6797FE",
    fillRule: "nonzero",
    d: "M16 14h-1.5a.5.5 0 0 1-.384-.82l2.5-3a.5.5 0 0 1 .768 0l2.5 3a.5.5 0 0 1-.384.82H18v2a3 3 0 0 1-3 3H6a2 2 0 0 1-2-2h11a1 1 0 0 0 1-1v-2zm-8-4h1.5a.5.5 0 0 1 .384.82l-2.5 3a.5.5 0 0 1-.768 0l-2.5-3A.5.5 0 0 1 4.5 10H6V8a3 3 0 0 1 3-3h9a2 2 0 0 1 2 2H9a1 1 0 0 0-1 1v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.a4049bd2c3a369061b2beb73bad80d0b.svg";
export { ForwardRef as ReactComponent };